import { ChangeEvent, useEffect, useState } from 'react';

import {
  ValidationConfig,
  FormProps,
  FormInput, Validity, FormValues,
} from '../types/index';
import { validateForm } from '../utils/validation.utils';

export function useValidation(config: ValidationConfig): { validity: Validity, formValues: FormValues, isFormValid: boolean, useGetValue: (fieldname: string) => any } {

  const [formProps, setFormProps] = useState<FormProps>({});
  const [validity, setValidity] = useState<Validity>({});
  const [isFormValid, setIsFormValid] = useState<boolean>(false);

  const useGetValue = (fieldname: string) => useGetFormInput({ fieldname, setFormProperties: setFormProperties });

  const setFormProperties = (props: FormProps) => {
    setFormProps({ ...formProps, ...props })
  };

  useEffect(() => {
   const { validity, isFormValid } =  validateForm(config, formProps);
   setValidity(validity);
   setIsFormValid(isFormValid);
  }, [formProps]);

  const formValues = Object.keys(formProps).reduce((acc, fieldName) => {
    acc[fieldName] = formProps[fieldName].value;
    return acc;
  }, {} as FormValues);

  return { validity, formValues, isFormValid, useGetValue };
}


export function useGetFormInput({ fieldname, setFormProperties: setFormData }: FormInput) {
  const [fieldProps, setFieldProps] = useState<FormProps>({ [fieldname]: { value: '', isTouched: false } });

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {

    const type = event.target.type;
    let value: string | number | boolean = '';

    switch (type) {
      case 'checkbox':
        value = event.target.checked;
        break;
      case 'text':
        value = event.target.value;
        break;
      default:
        value = event.target.value;
    }

    setFieldProps({ ...fieldProps, [fieldname]: { isTouched: fieldProps[fieldname].isTouched, value } })
  };

  const handleBlur = (): void => {
    setFieldProps({ ...fieldProps, [fieldname]: { value: fieldProps[fieldname].value, isTouched: true } })
  };

  useEffect(() => {
    setFormData(fieldProps);
  }, [fieldProps[fieldname].isTouched, fieldProps[fieldname].value]);

  return {
    fieldname,
    onChange: handleChange,
    onBlur: handleBlur,
  }
}
